import React, { useEffect, useState } from 'react'
import Layouts from '../layouts/Layouts'
import useBarangTerhapus from './features/useBarangTerhapus';
import useKategori from './features/useKategori';
import useCabang from './features/useCabang';
import { IconCalendarTime, IconEdit, IconRefresh, IconEye } from '@tabler/icons-react';
import { DateRangePicker } from 'react-date-range';
import { DinamicTitle } from '../utils/DinamicTitle';
import RestoreBarang from './Modal/RestoreBarang';
import { IconChevronLeft } from '@tabler/icons-react';
import { IconChevronRight } from '@tabler/icons-react';
import DetailItem from './Modal/DetailItem';
import { getAuthorizationHeader, http } from '../config/http';
import LoadingIndicator from '../components/LoadingIndicator';
import Input from '../components/Input';
import { IconSearch } from '@tabler/icons-react';
import { IconReload } from '@tabler/icons-react';

const BarangTerhapus = () => {
    DinamicTitle('List Barang dikeluarkan')
    const {
        barangTerhapus,
        loadingBarangTerhapus,
        selectedKategori,
        setSelectedKategori,
        selectJenisKategori,
        setSelectJenisKategori,
        setSelectCabang,
        karatOption,
        setKaratOptionId,
        selectionRange,
        getBarangTerhapus,
        handleSelect,
        prevPage,
        nextPage,
        currentPage,
        filterBeratBarang,
        setFilterBerat,
        page
    } = useBarangTerhapus();

    function reloadData() {
        getBarangTerhapus();
    }
    const { kategori, loadingKategori } = useKategori();
    const { cabang } = useCabang();
    const [selectedIds, setSelectedIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [isOpenModalRestore, setIsOpenModalRestore] = useState(false);
    const [detailItemTerhapus, setDetailItemTerhapus] = useState(null);
    const [isOpenDetailItemHapus, setIsOpenDetailItemHapus] = useState(false);
    const [openLoading, setOpenLoading] = useState(false);
    function closeDetailItemHapus() {
        setIsOpenDetailItemHapus(false);
    }
    function openDetailItemHapus() {
        setIsOpenDetailItemHapus(true);
    }
    const closeModalRestore = () => {
        setIsOpenModalRestore(false)
    }

    const handleSingleSelect = (id) => {
        const isSelected = selectedIds.includes(id);
        if (isSelected) {
            setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
        } else {
            setSelectedIds([...selectedIds, id]);
        }
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedIds([]);
            setSelectAll(false);
        } else {
            const allIds = barangTerhapus.map((bt) => bt.id);
            setSelectedIds(allIds);
            setSelectAll(true);
        }
    };

    const handleKategoriChange = (event) => {
        setSelectedKategori(event.target.value);
        setSelectJenisKategori('');
    };
    const handleJenisKategoriChange = (event) => {
        setSelectJenisKategori(event.target.value);
    };
    async function getDetailItemTerhapus(id) {
        // console.log(id);
        setOpenLoading(true);
        await http
            .get(`/trash/${id}`, {
                headers: { Authorization: getAuthorizationHeader() },
            })
            .then((res) => {
                setDetailItemTerhapus(res.data.data);
                openDetailItemHapus();
            });
        setOpenLoading(false);
    }

    const [itemsPerPage, setItemsPerPage] = useState('');
    const startIndex = (currentPage - 1) * itemsPerPage;

    return (
        <Layouts
            // title={'List Barang dikeluarkan'}
            compFilter={
                <div className='flex items-center gap-1.5'>
                    <button onClick={() => setIsOpenModalRestore(true)} className='bg-gradient-to-r from-emerald-500 to-emerald-600 hover:from-emerald-600 hover:to-emerald-700 px-3 py-2 text-white text-sm font-medium rounded-lg shadow-sm hover:shadow transition-all duration-200'>
                        Restore Barang
                    </button>
                    <div className="dropdown dropdown-bottom">
                        <div tabIndex={0} className="bg-amber-500 hover:bg-amber-600 text-white p-2 rounded-md cursor-pointer transition-colors shadow-sm">
                            <IconCalendarTime size={20} />
                        </div>
                        <div tabIndex={0} className="dropdown-content menu -right-36 p-2 shadow-lg bg-white dark:bg-slate-800 rounded-lg z-20">
                            <DateRangePicker ranges={[selectionRange]} onChange={handleSelect} />
                        </div>
                    </div>
                    <button onClick={reloadData} className="bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-200 p-2 rounded-md cursor-pointer transition-colors shadow-sm">
                        <IconReload size={20} />
                    </button>
                </div>
            }
        >
            <RestoreBarang
                reloadData={reloadData}
                selectedIds={selectedIds}
                closeModalRestore={closeModalRestore}
                isOpenModalRestore={isOpenModalRestore}
            />
            <DetailItem
                closeModalDetail={closeDetailItemHapus}
                detailItem={detailItemTerhapus}
                openDetail={isOpenDetailItemHapus}
            />
            {openLoading && <LoadingIndicator />}
            <div className='bg-white dark:bg-slate-900 mt-0.5 flex items-center gap-2 p-2 overflow-x-auto scrollbar'>
                <select
                    onChange={(e) => setSelectCabang(e.target.value)}
                    className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                >
                    <option value="">Etalase</option>
                    {cabang.map((cb) => (
                        <option key={cb.id} value={cb.id}>
                            {cb.nama_cabang}
                        </option>
                    ))}
                </select>
                <select
                    value={selectedKategori}
                    onChange={handleKategoriChange}
                    className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                >
                    <option value="">Kategori</option>
                    {loadingKategori && (
                        <option disabled value="">
                            Loading ...
                        </option>
                    )}
                    {kategori.map((kt) => (
                        <option key={kt.id} value={kt.id}>
                            {kt.nama_kategori}
                        </option>
                    ))}
                </select>
                {selectedKategori && (
                    <select
                        onChange={handleJenisKategoriChange}
                        value={selectJenisKategori}
                        className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                    >
                        <option value="">Jenis Kategori</option>
                        {kategori
                            .find((kt) => kt.id == selectedKategori)
                            ?.jenis_kategori.map((jk) => (
                                <option key={jk.id} value={jk.id}>
                                    {jk.nama_jenis}
                                </option>
                            ))}
                    </select>
                )}
                <select
                    onChange={(e) => setKaratOptionId(e.target.value)}
                    className="h-[2.5rem] px-3 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 text-sm rounded-md cursor-pointer focus:outline-none focus:border-amber-500 transition-colors shadow-sm"
                >
                    <option value="">Karat</option>
                    {karatOption.map((kto) => (
                        <option value={kto} key={kto}>
                            {kto}
                        </option>
                    ))}
                </select>
                <div className="flex items-center gap-1 w-44 shrink-0">
                    <Input
                        onChange={(e) => setFilterBerat(e.target.value)}
                        placeholder="Cari Berat"
                        className="border border-slate-200 dark:border-slate-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-slate-800 dark:text-slate-200 focus:border-amber-400 focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-900/30 transition-all outline-none w-full"
                    />
                    <button onClick={filterBeratBarang} className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 p-2 text-white rounded-lg shadow-sm hover:shadow transition-all duration-200 flex-shrink-0">
                        <IconSearch size={18} />
                    </button>
                </div>
            </div>
            {loadingBarangTerhapus ? (
                <div className="flex items-center justify-center py-10">
                    <div className="w-8 h-8 rounded-full animate-spin border-4 border-dashed border-amber-500 border-t-transparent"></div>
                    <span className="ml-3 text-sm font-medium text-slate-500 dark:text-slate-400">Memuat data...</span>
                </div>
            ) : (
                <div className="shadow-lg mt-0.5 rounded-lg overflow-hidden border border-slate-200 dark:border-slate-700">
                    <table className="w-full text-sm text-left">
                        <thead>
                            <tr className='bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30'>
                                <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">No.</th>
                                <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">Kode Barang</th>
                                <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">Nama Barang</th>
                                <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">Berat | Karat</th>
                                <th scope="col" className="py-3 px-3 text-left text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">Tanggal Hapus</th>
                                <th scope="col" className="py-3 px-3 text-center text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">Action</th>
                                <th scope="col" className="py-3 px-3 text-center text-xs font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider">
                                    <input
                                        type="checkbox"
                                        checked={selectAll}
                                        className='cursor-pointer checkbox checkbox-warning w-[18px] h-[18px] border-amber-400 dark:border-slate-500 rounded transition-all'
                                        onChange={handleSelectAll}
                                    />
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white dark:bg-slate-900 divide-y divide-slate-100 dark:divide-slate-800">
                            {barangTerhapus.map((bt, i) => (
                                <tr key={i} className='group hover:bg-amber-50/50 dark:hover:bg-slate-800/60 cursor-pointer transition-colors'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        getDetailItemTerhapus(bt.id);
                                    }}
                                >
                                    <td className="py-2.5 px-3 text-slate-500 dark:text-slate-400 text-xs font-medium">
                                        {startIndex + i + 1}.
                                    </td>
                                    <td className="py-2.5 px-3 text-amber-700 dark:text-amber-400 font-semibold text-sm truncate">{bt.kode_item}</td>
                                    <td className="py-2.5 px-3 text-slate-800 dark:text-slate-200 font-medium text-sm truncate">{bt.jenis_kategori.nama_jenis}</td>
                                    <td className="py-2.5 px-3 text-slate-600 dark:text-slate-300 text-sm">{`${bt.berat} gr | ${bt.karat} Krt`}</td>
                                    <td className="py-2.5 px-3 text-slate-500 dark:text-slate-400 text-sm">
                                        {bt.created_at}
                                    </td>
                                    <td className="py-2.5 px-3 text-center">
                                        <button onClick={(e) => {
                                            e.stopPropagation();
                                            getDetailItemTerhapus(bt.id)
                                        }} className='w-7 h-7 rounded-md flex items-center justify-center text-amber-600 bg-amber-50 hover:bg-amber-500 hover:text-white dark:text-amber-400 dark:bg-amber-500/20 dark:hover:bg-amber-500 dark:hover:text-white transition-all shadow-sm hover:shadow' title="Lihat Detail">
                                            <IconEye size={16} stroke={1.5} />
                                        </button>
                                    </td>
                                    <td className="py-2.5 px-3 text-center">
                                        <input
                                            onClick={(e) => e.stopPropagation()}
                                            checked={selectedIds.includes(bt.id)}
                                            onChange={() => handleSingleSelect(bt.id)}
                                            className='cursor-pointer checkbox checkbox-warning w-[18px] h-[18px] border-amber-400 dark:border-slate-500 rounded transition-all'
                                            type="checkbox"
                                        />
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>

                </div>
            )}
            <div className='bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 bottom-0 left-0 py-3 w-full absolute'>
                <div className="items-center flex justify-end space-y-2 text-sm sm:space-y-0 sm:space-x-3 mr-4 sm:flex">
                    <span className="block text-slate-600 dark:text-slate-400">
                        Halaman <span className="font-semibold text-amber-600 dark:text-amber-400">{currentPage}</span> dari <span className="font-semibold">{page}</span>
                    </span>
                    <div className="space-x-1">
                        <button
                            onClick={prevPage}
                            disabled={currentPage <= 1}
                            title="previous"
                            type="button"
                            className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-md shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 disabled:opacity-40 transition-colors"
                        >
                            <IconChevronLeft size={18} />
                        </button>
                        <button
                            onClick={nextPage}
                            disabled={currentPage >= page}
                            title="next"
                            type="button"
                            className="inline-flex items-center justify-center w-8 h-8 py-0 border border-slate-300 dark:border-slate-600 rounded-md shadow-sm bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 disabled:opacity-40 transition-colors"
                        >
                            <IconChevronRight size={18} />
                        </button>
                    </div>
                </div>
            </div>
        </Layouts>
    )
}

export default BarangTerhapus